import React, { createContext, useState, useContext, useEffect } from 'react';
import { CircularProgress, Backdrop } from '@mui/material';

const LoaderContext = createContext();

export const useLoader = () => useContext(LoaderContext);

export const LoaderProvider = ({ children }) => {
  const [loaders, setLoaders] = useState({});
  const [visibleLoaders, setVisibleLoaders] = useState({});
  const [showGlobalLoader, setShowGlobalLoader] = useState(false);

  // Start a loader with a delay
  const startLoader = (requestId) => {
    setLoaders(prev => ({
      ...prev,
      [requestId]: {
        active: true,
        /*
        timer: setTimeout(() => {
          setVisibleLoaders(prev => ({
            ...prev,
            [requestId]: true
          }));
        }, 3000) // Only show loader after 3 seconds
        */
        timer: setVisibleLoaders(prev => ({
          ...prev,
          [requestId]: true
        }))
      }
    }));
  };

  // Stop a loader and clear its timer
  const stopLoader = (requestId) => {
    if (loaders[requestId] && loaders[requestId].timer) {
      clearTimeout(loaders[requestId].timer);
    }
    
    setLoaders(prev => {
      const newLoaders = { ...prev };
      delete newLoaders[requestId];
      return newLoaders;
    });
    
    setVisibleLoaders(prev => {
      const newVisibleLoaders = { ...prev };
      delete newVisibleLoaders[requestId];
      return newVisibleLoaders;
    });
  };

  // Check if any loaders are visible
  useEffect(() => {
    const anyVisible = Object.values(visibleLoaders).some(visible => visible);
    setShowGlobalLoader(anyVisible);
  }, [visibleLoaders]);

  return (
    <LoaderContext.Provider value={{ startLoader, stopLoader }}>
      {children}
      <Backdrop
        sx={{ 
          color: '#fff', 
          zIndex: (theme) => theme.zIndex.drawer + 1,
          display: showGlobalLoader ? 'flex' : 'none'
        }}
        open={showGlobalLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </LoaderContext.Provider>
  );
};
